import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=349c9c3e&scoped=true&"
import script from "./Contacts.vue?vue&type=script&lang=js&"
export * from "./Contacts.vue?vue&type=script&lang=js&"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=349c9c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349c9c3e",
  null
  
)

export default component.exports